export default "__VITE_ASSET__CMqh4xZI__"